import { reducerRegistry } from '../../../../reducerRegistry';

import listsReducersMap from './lists/reducersMap';
import collectionsReducersMap from './collections/reducersMap';
import formsReducersMap from './forms/reducersMap';
import statesReducersMap from './states/reducersMap';

const combineMap = {
  lists: listsReducersMap,
  collections: collectionsReducersMap,
  forms: formsReducersMap,
  states: statesReducersMap
};

export default function combineRegistry() {
  reducerRegistry.registerByCombineMap('usersModule', combineMap);
}



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/users/reducers/static/combineRegistry.js